class NavigationProgress {
  constructor(options = {}) {
    this.progressBar = null;
    this.autoCompleteTimeout = null;
    this.startTime = null;
    this.isRunning = false;
    this.config = {
      className: "navigation-progress", animationDuration: 1000, completeDelay: 300, cleanupDelay: 700, ...options
    };
  }

  start() {
    if (this.isRunning) {
      return;
    }

    this.isRunning = true;
    this.startTime = Date.now();
    this.create();

    this.autoCompleteTimeout = setTimeout(() => {
      this.forceComplete();
    }, this.config.animationDuration);
  }

  reset() {
    this.isRunning = false;
    this.startTime = null;

    if (this.autoCompleteTimeout) {
      clearTimeout(this.autoCompleteTimeout);
      this.autoCompleteTimeout = null;
    }

    if (this.progressBar) {
      this.progressBar.remove();
      this.progressBar = null;
    }
  }

  create() {
    if (this.progressBar) return this.progressBar;

    this.progressBar = document.createElement("div");
    this.progressBar.className = this.config.className;

    document.body.appendChild(this.progressBar);

    requestAnimationFrame(() => {
      if (this.progressBar) {
        this.progressBar.classList.add("loading");
      }
    });

    return this.progressBar;
  }


  forceComplete() {
    if (!this.isRunning) {
      return;
    }

    this.isRunning = false;

    if (this.autoCompleteTimeout) {
      clearTimeout(this.autoCompleteTimeout);
      this.autoCompleteTimeout = null;
    }

    if (this.progressBar) {
      this.progressBar.classList.add("complete");
    }

    setTimeout(() => {
      this.remove();
    }, this.config.completeDelay);

    this.startTime = null;
  }

  remove() {
    if (!this.progressBar) return;

    setTimeout(() => {
      if (this.progressBar && this.progressBar.parentNode) {
        this.progressBar.parentNode.removeChild(this.progressBar);
      }
      this.progressBar = null;
    }, this.config.cleanupDelay);
  }

  cancel() {
    this.isRunning = false;

    if (this.autoCompleteTimeout) {
      clearTimeout(this.autoCompleteTimeout);
      this.autoCompleteTimeout = null;
    }

    this.remove();
    this.startTime = null;
  }

  destroy() {
    this.cancel();
    this.config = null;
  }
}

export default NavigationProgress; 